module.exports = __webpack_public_path__ + "img/ດິສນີ້-711x400.5279522f.jpg";